import { useEffect, useState } from "react";

const useDismissibleAlerts = (initialAlerts) => {
  const [alerts, setAlerts] = useState(initialAlerts);

  const dismissAlert = (alertID) => {
    const dismissedAlerts = alerts.map((alert) =>
      alert.ID === alertID
        ? { ...alert, dismissed: true, dismissedAt: new Date().getTime() }
        : alert
    );
    setAlerts(dismissedAlerts);
    const dismissedAlert = dismissedAlerts.find(
      (alert) => alert.ID === alertID && alert.dismissed
    );
    if (dismissedAlert) {
      const storedDismissedAlerts =
        JSON.parse(localStorage.getItem("dismissedAlerts")) || [];
      storedDismissedAlerts.push(dismissedAlert);
      localStorage.setItem(
        "dismissedAlerts",
        JSON.stringify(storedDismissedAlerts)
      );
    }
  };

  // on mount, check if any alerts have been dismissed in the last 30 days and update the alerts accordingly
  useEffect(() => {
    // clears alert when server data has no alerts, but hooks state has alerts
    if (!initialAlerts.length > 0 && alerts.length > 0) {
      setAlerts(initialAlerts);
      return;
      // if there are no alerts, do nothing
    } else if (!initialAlerts.length > 0) {
      return;
    }
    const storedDismissedAlerts =
      JSON.parse(localStorage.getItem("dismissedAlerts")) || [];
    const currentTime = new Date().getTime();
    const validDismissedAlerts = storedDismissedAlerts.filter(
      (alert) => currentTime - alert.dismissedAt <= 30 * 24 * 60 * 60 * 1000
    );
    localStorage.setItem(
      "dismissedAlerts",
      JSON.stringify(validDismissedAlerts)
    );
    const updatedAlerts = initialAlerts?.map((alert) => ({
      ...alert,
      dismissed: validDismissedAlerts.some(
        (dismissedAlert) => dismissedAlert.ID === alert.ID
      ),
    }));
    setAlerts(updatedAlerts);
  }, [initialAlerts, alerts.length]);

  return { alerts, dismissAlert };
};

export default useDismissibleAlerts;
